// extracted by mini-css-extract-plugin
export default {"banner":"Home_banner__mewYe","titulliPershkrim":"Home_titulliPershkrim__8plpJ","artikujt":"Home_artikujt__FLTO-","titulliArtikuj":"Home_titulliArtikuj__9GC5F"};